var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.326 14.899l5.38 5.38a1.009 1.009 0 01-1.427 1.426l-5.38-5.38a8 8 0 111.426-1.426zM10 15.999a6 6 0 100-12 6 6 0 000 12z",
    fill: "#ACB0B5"
  })));
}

export default SvgIconSearchDisable;